"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataIngestApi = exports.DataIngestApiFactory = exports.DataIngestApiFp = exports.DataIngestApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DataIngestApi - axios parameter creator
 * @export
 */
const DataIngestApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} [categoryId]
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataIngestIngest: (categoryId_1, requestBody_1, ...args_1) => __awaiter(this, [categoryId_1, requestBody_1, ...args_1], void 0, function* (categoryId, requestBody, options = {}) {
            const localVarPath = `/datasets/push`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.DataIngestApiAxiosParamCreator = DataIngestApiAxiosParamCreator;
/**
 * DataIngestApi - functional programming interface
 * @export
 */
const DataIngestApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DataIngestApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [categoryId]
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataIngestIngest(categoryId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.dataIngestIngest(categoryId, requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DataIngestApi.dataIngestIngest']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.DataIngestApiFp = DataIngestApiFp;
/**
 * DataIngestApi - factory interface
 * @export
 */
const DataIngestApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DataIngestApiFp)(configuration);
    return {
        /**
         *
         * @param {DataIngestApiDataIngestIngestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dataIngestIngest(requestParameters = {}, options) {
            return localVarFp.dataIngestIngest(requestParameters.categoryId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DataIngestApiFactory = DataIngestApiFactory;
/**
 * DataIngestApi - object-oriented interface
 * @export
 * @class DataIngestApi
 * @extends {BaseAPI}
 */
class DataIngestApi extends base_1.BaseAPI {
    /**
     *
     * @param {DataIngestApiDataIngestIngestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataIngestApi
     */
    dataIngestIngest(requestParameters = {}, options) {
        return (0, exports.DataIngestApiFp)(this.configuration).dataIngestIngest(requestParameters.categoryId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DataIngestApi = DataIngestApi;
//# sourceMappingURL=data-ingest-api.js.map